module.exports = __webpack_public_path__ + "static/media/arrow_down_icon.59858367.svg";